var CommonController = function() {
    this.Pagetop = require('../module/pagetop');
    this.Mailto = require('../module/mailto');
    this.init();
};

CommonController.prototype = {
    init: function() {
        var pagetop = new this.Pagetop({
            id: '#js-pagetop',
            duration: 1
        });
        pagetop.init();
        require('../module/headerSideScroll');

        var mailto = new this.Mailto();
        mailto.replace();
    }
};

module.exports = CommonController;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/controller/CommonController.js
 **/